
import RetroFormLayout from "../../components/RetroFormLayout";
import MediaModal from "./MediaModal";
import {
  RetroInput, RetroButton, RetroDeleteButton, RetroTextarea,
  RetroSelect,RetroFileInput,} from "../../components/RetroFields";
import { useFormProduct } from "../../hooks/useFormProduct";

const ProductForm = ({ initialProduct, onClose, onSuccess  }) => {
    const {
    product,
    previews,
    categories,
    errors,
    showMediaModal,
    setShowMediaModal,
    fileInputRef,
    titleText,
    handleChange,
    handleCoverImageChange,
    handleAddMedia,
    handleRemoveMedia,
    handleSubmit,
    removeProduct,
  } = useFormProduct({ initialProduct, onSuccess });


  return (
    <RetroFormLayout title={titleText} onSubmit={handleSubmit}>


      <RetroInput
        label="Name"
        name="name"
        value={product.name}
        onChange={handleChange}
        error={errors.name}
      />


      <RetroTextarea
        label="Description"
        name="description"
        value={product.description}
        onChange={handleChange}
      />



      <RetroSelect
        label="Catégorie"
        name="category"
        value={product.category}
        onChange={handleChange}
        options={categories.map((c) => ({
          value: c.id,
          label: c.name.toUpperCase(),
        }))}
        error={errors.category}
      />



      <RetroInput
        label="Stock"
        type="number"
        name="stock"
        value={product.stock}
        onChange={handleChange}
      />


      <RetroInput
        label="Prix (€)"
        type="number"
        step="0.01"
        name="price"
        value={product.price}
        onChange={handleChange}
      />

      {/* COVER IMAGE */}

      <RetroFileInput
        ref={fileInputRef}
        label="Image de couverture"
        name="coverImage"
        onChange={handleCoverImageChange}
        error={errors.coverImage}
      />
      {previews.cover && (
        <>
        <div style={{display : "flex", justifyContent : 'center'}}>
        <img
          src={previews.cover}
          alt="Cover Preview"
          style={{
            maxWidth: "150px",
            maxHeight: 200,
            border: "1px solid #00ff00",
            marginBottom: 20,
          }}
        />
        </div>
        </>
      )}

      <div style={{ margin: "20px 0" }}>
        <h4 style={{ color: "#00ff00" }}>Médias ajoutés:</h4>
        {product.medias.length === 0 ? (
          <p style={{ color: "#888" }}>Aucun média ajouté.</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #00ff00" }}>
                <th
                  style={{textAlign: "left", color: "#00ff00", padding: "8px",
                  }}
                > Type
                </th>
                <th
                  style={{ textAlign: "left", color: "#00ff00", padding: "8px",
                  }}
                > Contenu
                </th>
                <th
                  style={{ textAlign: "left", color: "#00ff00", padding: "8px"}}
                >
                  Cover
                </th>
                {/* <th style={{ textAlign: "left", color: "#00ff00", padding: "8px" }}>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {product.medias.map((media, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #333" }}>
                  <td style={{ color: "#00ff00", padding: "8px" }}>
                    {media.type}
                  </td>
                  <td style={{ color: "#00ff00", padding: "8px" }}>
                    {media.type === "image" ? (
                      <img
                        src={previews.medias[index]}
                        alt={`media-${index}`}
                        style={{ maxWidth: "100px", maxHeight: "100px" }}
                      />
                    ) : (
                      <a
                        href={media.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#00ff00",
                          display: "inline-block",
                          maxWidth: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Lien
                      </a>
                    )}
                  </td>
                  <td style={{ padding: "8px", alignContent: "center" }}>
                    {media.isCoverImage && (
                      <span style={{ color: "#00ff00", fontSize: "16px" }}>
                        🍄
                      </span>
                    )}
                  </td>
                  <td style={{ padding: "8px" }}>
                    <button
                      type="button"
                      onClick={() => handleRemoveMedia(index)}
                      style={{
                        backgroundColor: "#ff0000",
                        color: "#fff",
                        border: "none",
                        padding: "5px 10px",
                        cursor: "pointer",
                      }}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <RetroButton
          type="button"
          onClick={() => setShowMediaModal(true)}
          style={{ marginBottom: 20, padding: "8px", fontSize: "12px" }}
        >
          Ajouter un média
        </RetroButton>
      </div>

      {/* Bottone submit */}

      
      <RetroButton type="submit">Enregistrer</RetroButton>

      { initialProduct &&
      <>
      <RetroDeleteButton onConfirm={removeProduct}></RetroDeleteButton>
      
      <RetroButton
          type="button"
          onClick={() => {
            onClose()
          }}
          style={{ backgroundColor: "#ffa500" }}
        >
          Annuler
        </RetroButton>
        </>
    }

      {/* Modale per aggiungere media */}
      {showMediaModal && (
        <MediaModal
          onClose={() => setShowMediaModal(false)}
          onAddMedia={handleAddMedia}
        />
      )}
    </RetroFormLayout >
  );
};

export default ProductForm;
